import React from 'react'
import PropTypes from 'prop-types'
import PlayerScrubber from '../scrubber/PlayerScrubber'

import "./PlayerProgress.css";

export default class ProgressBar extends React.PureComponent {

	render() {
		
		let { progress, buffered } = this.props
		
		return (
			<div className="progress-bar">
		 		<div className="progress-bar__bg">
					<div className="progress-bar__fg-buffered" style={{width: `${ buffered * 100}%`}} />
					<div className="progress-bar__fg" style={{width: `${ progress * 100}%`}}>
						<PlayerScrubber />
					</div>
				</div>
		 	</div>
		)
	}
}

ProgressBar.propTypes = {
	buffered: PropTypes.number,
	progress: PropTypes.number
}



// WEBPACK FOOTER //
// ./src/components/player/controls/progress/PlayerProgress.jsx